var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStandup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3FFFC",
    d: "M48.75 60h-37.5C5.036 60 0 54.964 0 48.75v-37.5C0 5.036 5.036 0 11.25 0h37.5C54.964 0 60 5.036 60 11.25v37.5C60 54.964 54.964 60 48.75 60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EB9A2",
    d: "M26.563 24.688h-1.875c-.692 0-1.25.56-1.25 1.25s.558 1.251 1.25 1.251h1.875v1.562c-1.723 0-3.125 1.403-3.125 3.126v2.188c0 .69.558 1.25 1.25 1.25h3.126c.692 0 1.25-.56 1.25-1.25s-.56-1.252-1.252-1.252h-1.875v-.938c0-.345.281-.624.624-.624 1.378 0 2.5-1.122 2.5-2.5v-1.564c.002-1.378-1.12-2.499-2.498-2.499zM35.312 24.688c-.692 0-1.25.56-1.25 1.25v3.125h-1.25v-3.126c0-.69-.558-1.25-1.25-1.25s-1.25.56-1.25 1.25v3.125c0 1.379 1.12 2.5 2.499 2.5h1.25v2.5c0 .69.559 1.25 1.25 1.25.693 0 1.252-.56 1.252-1.25v-8.125c0-.69-.56-1.249-1.251-1.249z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EB9A2",
    d: "M30 15c-8.273 0-15 6.73-15 15s6.73 15 15 15 15-6.73 15-15-6.727-15-15-15zm.938 27.452v-1.515c0-.518-.42-.938-.938-.938-.517 0-.938.42-.938.938v1.515c-6.144-.46-11.056-5.37-11.516-11.514h1.515c.518 0 .938-.42.938-.938 0-.517-.42-.938-.938-.938h-1.515c.46-6.144 5.372-11.055 11.517-11.514v1.515c0 .518.42.938.937.938.517 0 .938-.42.938-.938v-1.515c6.144.46 11.056 5.37 11.516 11.515h-1.515c-.518 0-.938.42-.938.937 0 .517.42.938.938.938h1.515c-.46 6.144-5.372 11.055-11.517 11.514z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStandup);
export default __webpack_public_path__ + "static/media/ic-standup.81f7a550.svg";
export { ForwardRef as ReactComponent };